// Typed access to import.meta.env. Add new keys here when introducing them.

interface Env {
  readonly VITE_API_BASE_URL: string;
  readonly VITE_AUTH_ENABLED: 'true' | 'false';
  readonly VITE_AUTH_TENANT_ID: string;
  readonly VITE_AUTH_CLIENT_ID: string;
  readonly VITE_AUTH_API_SCOPE: string;
  // Phase security-housekeeping (TODO-089) — total idle minutes before
  // the SessionTimeoutWarning component logs the user out. Default 60.
  readonly VITE_SESSION_TIMEOUT_MINUTES: string;
}

const raw = import.meta.env as unknown as Env;

export const env: Env = {
  VITE_API_BASE_URL: raw.VITE_API_BASE_URL ?? '',
  VITE_AUTH_ENABLED: (raw.VITE_AUTH_ENABLED ?? 'false') as 'true' | 'false',
  VITE_AUTH_TENANT_ID: raw.VITE_AUTH_TENANT_ID ?? '',
  VITE_AUTH_CLIENT_ID: raw.VITE_AUTH_CLIENT_ID ?? '',
  VITE_AUTH_API_SCOPE: raw.VITE_AUTH_API_SCOPE ?? '',
  VITE_SESSION_TIMEOUT_MINUTES: raw.VITE_SESSION_TIMEOUT_MINUTES ?? '',
};

export const isAuthEnabled = (): boolean => env.VITE_AUTH_ENABLED === 'true';
